import React from 'react';

import { CodeStyled } from './Code.style';

export const Code = ({ children, ...props }: { children: any }) => {
  return <CodeStyled {...props}>{children}</CodeStyled>;
};
